import {Vue} from 'ui.vue';

import Const, {
    ACTION_TYPE_REG,
    AUTH_BY_EMAIL_CODE,
    AUTH_BY_PASSWORD,
    AUTH_BY_PHONE,
    CONFIRM_TYPE_BOT_SPEECH
} from './Const';

import 'bxmaker.authuserphone.core';
import './components/BXmakerAuthuserphoneEnter.js';


export class Enter {
    constructor(rootId, data) {
        this.rootId = rootId;
        this.data = data;
        this.rand = data.rand;
        this.instance = null;

        this.initTemplate()
    }

    initTemplate() {
        const context = this;

        this.instance = Vue.createApp({
            name: 'BXmakerAuthuserphoneEnterContainer__' + this.rand,
            key: this.rand,
            data() {
                return {
                    data: context.data,
                    rand: context.data.rand,

                    isEnabledReload: true,
                    isEnabledRedirect: true,

                    isAuthorized: context.data.isAuthorized,

                    isEnabledRegister: context.data.isEnabledRegister,

                    confirmQueue: context.data.confirmQueue,

                    isEnabledConfirmBySmsCode: context.data.isEnabledConfirmBySmsCode,
                    isEnabledConfirmByUserCall: context.data.isEnabledConfirmByUserCall,
                    isEnabledConfirmByBotCall: context.data.isEnabledConfirmByBotCall,
                    isEnabledConfirmByBotSpeech: context.data.isEnabledConfirmByBotSpeech,
                    isEnabledConfirmBySimPush: context.data.isEnabledConfirmBySimPush,
                    isEnabledConfirmByEmailCode: context.data.isEnabledConfirmByEmailCode,

                    isEnabledAuthByLogin: context.data.isEnabledAuthByLogin,
                    isEnabledAuthByEmail: context.data.isEnabledAuthByEmail,

                    isEnabledRegisterFIO: context.data.isEnabledRegisterFIO,

                    isEnabledRegisterFIOSplit: context.data.isEnabledRegisterFIOSplit,
                    isEnabledRegisterLastName: context.data.isEnabledRegisterLastName,
                    isEnabledRegisterFirstName: context.data.isEnabledRegisterFirstName,
                    isEnabledRegisterSecondName: context.data.isEnabledRegisterSecondName,


                    isEnabledRegisterBirthday: context.data.isEnabledRegisterBirthday,
                    isEnabledRegisterLogin: context.data.isEnabledRegisterLogin,
                    isEnabledRegisterEmail: context.data.isEnabledRegisterEmail,
                    isEnabledRegisterPassword: context.data.isEnabledRegisterPassword,

                    registerFIODadata: context.data.registerFIODadata,

                    isEnabledRestoreByEmail: context.data.isEnabledRestoreByEmail,

                    isEnabledRequestConsent: context.data.isEnabledRequestConsent,

                    phoneMaskParams: context.data.phoneMaskParams,

                    actionType: Const.ACTION_TYPE_AUTH, //������� �������� - �����������  ACTION_TYPE_AUTH, ACTION_TYPE_REG, ACTION_TYPE_FORGET,

                    lastMethod: '',

                    confirmationType: Const.CONFIRM_TYPE_SMS_CODE, // ������� ��� ������������� - ��� ����, ������ �� ���� � ��


                    isShowConfirm: false, // ���������� ���� � ���������
                    authBy: context.data.isEnabledAuthByPasswordFirst ? Const.AUTH_BY_PASSWORD : Const.AUTH_BY_PHONE,


                    consentLoader: false, // ����������� ����������
                    consentText: false, // ����� ����������
                    isConsentReceived: false, // ������� ��������


                    isEnabledRequestAdsAgreement: context.data.isEnabledRequestAdsAgreement,
                    requestAdsAgreementLabel: context.data.requestAdsAgreementLabel,
                    isAdsAgreementReceived: false, // ������� ��������


                    captchaId: '',
                    captchaCode: '',
                    captchaSrc: '',
                    captchaLength: 5,
                    captchaLoader: false,

                    ple: '', // �������, �����, email
                    dadataItem: null, // ���
                    fio: '', // ���
                    firstName: '', // ���
                    lastName: '', // �������
                    secondName: '', // ��������
                    birthday: '', // ���� ��������
                    phone: '', // ��������� �������
                    formattedPhone: '', // ��������������� ����� ��������
                    email: '', // ��������� email
                    login: '', // ��������� �����
                    password: '', // ��������� ������

                    message: false, // ���������
                    error: false, // ��������� �� �������

                    expandData: {},


                    authByPasswordLoader: false,  //����������� �� ������
                    authByPhoneLoader: false, // ����������� ����� ������������� ������ ��������
                    forgetLoader: false, // �������������� �������
                    registerLoader: false, // �����������

                    // sms
                    smsCodeLength: 4,
                    smsCodeTimeout: 0,
                    smsCode: '',
                    smsCodeError: '',
                    smsCodeStartLoader: false,
                    smsCodeCheckLoader: false,

                    //�������� ����� ������ �� ������������
                    userCallTo: '',
                    userCallStartLoader: false,
                    userCallCheckLoader: false,
                    userCallTimeout: 0,

                    // ������ �� ������
                    botCallCode: '',
                    botCallLength: 4,
                    botCallTimeout: 0,
                    botCallStartLoader: false,
                    botCallCheckLoader: false,

                    // ��������� ���
                    botSpeechCode: '',
                    botSpeechLength: 4,
                    botSpeechTimeout: 0,
                    botSpeechStartLoader: false,
                    botSpeechCheckLoader: false,

                    // sim-PUSH
                    simPush: '',
                    simPushTimeout: 0,
                    simPushDelay: 3,
                    simPushStartLoader: false,
                    simPushCheckLoader: false,


                    //bxmaker.authsueremail
                    emailCodeLength: 4,
                    emailCodeTimeout: 0,
                    emailCode: '',
                    emailCodeError: '',
                    emailCodeStartLoader: false,
                    emailCodeCheckLoader: false,

                    authByEmailCodeLoader: false, // ����������� ������� �����������

                };
            },
            computed: {
                localize() {
                    return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_ENTER_');
                },
                const() {
                    return Const;
                },

                // ������� ������ ��������� ��� ������� �� ajax
                baseAjaxData() {
                    let confirmType = '';
                    let confirmValue = '';
                    if (this.isConfirmBySmsCode) {
                        confirmType = this.const.CONFIRM_TYPE_SMS_CODE;
                        confirmValue = this.smsCode;
                    } else if (this.isConfirmByUserCall) {
                        confirmType = this.const.CONFIRM_TYPE_USER_CALL;
                        confirmValue = this.userCallTo;
                    } else if (this.isConfirmByBotCall) {
                        confirmType = this.const.CONFIRM_TYPE_BOT_CALL;
                        confirmValue = this.botCallCode;
                    } else if (this.isConfirmByBotSpeech) {
                        confirmType = this.const.CONFIRM_TYPE_BOT_SPEECH;
                        confirmValue = this.botSpeechCode;
                    } else if (this.isConfirmBySimPush) {
                        confirmType = this.const.CONFIRM_TYPE_SIM_PUSH;
                        confirmValue = this.simPush;
                    } else if (this.isConfirmByEmailCode) {
                        confirmType = this.const.CONFIRM_TYPE_EMAIL_CODE;
                        confirmValue = this.emailCode;
                    }

                    return {
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        rand: this.data.rand,

                        expandData: {...this.expandData},
                        confirmType: confirmType,
                        confirmValue: confirmValue,
                        actionType: this.actionType,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    }
                },

                isAuthByPhone() {
                    return this.authBy === Const.AUTH_BY_PHONE ;
                },
                isAuthByPassword() {
                    return this.authBy === Const.AUTH_BY_PASSWORD;
                },
                isAuthByEmailCode() {
                    return this.authBy === Const.AUTH_BY_EMAIL_CODE;
                },

                isNeedShowAuthByPhoneForm() {
                    return  !this.$root.isShowConfirm
                    && this.isAuthByPhone ;
                },
                isNeedShowAuthByPasswordForm() {
                    return  !this.$root.isShowConfirm
                        && this.isAuthByPassword ;
                },
                isNeedShowAuthByEmailCodeForm() {
                    return  !this.$root.isShowConfirm
                        && this.isAuthByEmailCode ;
                },


                /**
                 * ������ ������ ��������� ������������� ������ ��������
                 * � ������ ��� �������
                 * @returns {string[]}
                 */
                confirmationList() {
                    let list = this.data.confirmQueue;

                    if (!this.isEnabledConfirmBySmsCode) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    if (!this.isEnabledConfirmByUserCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_USER_CALL);
                    }
                    if (!this.isEnabledConfirmByBotCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_CALL);
                    }
                    if (!this.isEnabledConfirmByBotSpeech) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_SPEECH);
                    }
                    if (!this.isEnabledConfirmBySimPush) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SIM_PUSH);
                    }

                    if (list.length <= 0) {
                        list.push(this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    return list;
                },

                startLoader() {
                    return this.smsCodeStartLoader || this.userCallStartLoader
                        || this.botCallStartLoader || this.botSpeechStartLoader
                        || this.simPushStartLoader || this.authByPasswordLoader
                        || this.authByPhoneLoader
                        || this.emailCodeStartLoader;
                },

                checkLoader() {
                    return this.smsCodeCheckLoader || this.userCallCheckLoader
                        || this.botCallCheckLoader || this.botSpeechCheckLoader
                        || this.simPushCheckLoader || this.authByPasswordLoader
                        || this.authByPhoneLoader
                        || this.emailCodeCheckLoader;
                },

                isConfirmBySmsCode() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE;
                },
                isConfirmByUserCall() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL;
                },
                isConfirmByBotCall() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL;
                },
                isConfirmByBotSpeech() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH;
                },
                isConfirmBySimPush() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_SIM_PUSH;
                },
                isConfirmByEmailCode() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_EMAIL_CODE;
                },

                isNeedShowConfirmSmsCode() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmBySmsCode;
                },
                isNeedShowConfirmUserCall() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByUserCall;
                },
                isNeedShowConfirmBotCall() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByBotCall;
                },
                isNeedShowConfirmBotSpeech() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByBotSpeech;
                },
                isNeedShowConfirmSimPush() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmBySimPush;
                },
                isNeedShowConfirmEmailCode() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByEmailCode;
                },

                isNeedShowChangeConfirm() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationList.length > 1
                        && !this.isAuthByEmailCode;
                },

                // ������� ������� � �������� ��� ������� �����
                isFullCaptcha() {
                    if (!this.captchaId) {
                        return true;
                    }

                    if (this.captchaLength === this.captchaCode.toString().length) {
                        return true;
                    }

                    return false;
                },

                // ������� ������������
                actionTypeIsAuth() {
                    return this.actionType === Const.ACTION_TYPE_AUTH;
                },
                // ������� �����������
                actionTypeIsReg() {
                    return this.actionType === Const.ACTION_TYPE_REG;
                },
                // ������� �������������� ������
                actionTypeIsForget() {
                    return this.actionType === Const.ACTION_TYPE_FORGET;
                },
                isEnabledPhoneMaskTypeBitrix() {
                    return this.phoneMaskParams && this.phoneMaskParams.type && this.phoneMaskParams.type === 'bitrix';
                },

            },
            watch: {
                actionType(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeActionType', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                confirmationType(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeConfirmationType', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                isShowConfirm(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeShowConfirm', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                isAuthByPassword(val, oldVal) {
                    //todo �������� �� ���
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeIsAuthByPassword', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                }

            },
            created() {
                if (this.confirmationList.length > 0 && this.confirmationList[0] !== this.confirmationType) {
                    this.setConfirmType(this.confirmationList[0]);
                }

                if (location.hash === '#reg' && this.isEnabledRegister) {
                    this.toRegistration();
                }

            },
            methods: {
                resetExpandData() {
                    this.expandData = {};
                },
                setExpandData(name, value) {
                    this.expandData[name] = value;
                },

                // ���������/���������� ������������ �������� ����� �����������
                setIsEnabledReload(flag) {
                    this.isEnabledReload = !!flag;
                },

                // ����������/���������� ��������� ����� �����������
                setIsEnabledRedirect(flag) {
                    this.isEnabledRedirect = !!flag;
                },


                // ��������� ���� - ���
                setFIO(value) {
                    this.fio = value;
                },

                setFirstName(value) {
                    this.firstName = value;
                },

                setLastName(value) {
                    this.lastName = value;
                },

                setSecondName(value) {
                    this.secondName = value;
                },

                setBirthday(value) {
                    this.birthday = value;
                },

                setDadataItem(item) {
                    this.dadataItem = item;
                },

                // ��������� ���� - �������, �����, email
                setPLE(value) {
                    this.ple = value;
                },

                //  ���������/���������� ����� �� ������
                setIsAuthByPassword(value) {
                    this.isAuthByPassword = value;
                },

                // ��������� ��������
                setPhone(value) {
                    this.phone = value;
                },


                setFormattedPhone(value) {
                    this.formattedPhone = value;
                },
                setLogin(value) {
                    this.login = value;
                },

                setEmail(value) {
                    this.email = value;
                },
                setPassword(value) {
                    this.password = value;
                },

                setIsAuthorized(value) {
                    this.isAuthorized = !!value;
                },

                setAuthByPhone() {
                    this.authBy = Const.AUTH_BY_PHONE;
                    this.setConfirmType(this.confirmationList[0]);
                },
                setAuthByPassword() {
                    this.authBy = Const.AUTH_BY_PASSWORD;
                },
                setAuthByEmailCode() {
                    this.authBy = Const.AUTH_BY_EMAIL_CODE;
                    this.setConfirmType(Const.CONFIRM_TYPE_EMAIL_CODE);
                },

                // ���������/������ ����� �������� ���������� �� ������
                setAuthByPasswordLoader(value) {
                    this.authByPasswordLoader = !!value;
                },

                // ���������/������ ����� �������� ���������� �� ������
                setAuthByPhoneLoader(value) {
                    this.authByPhoneLoader = !!value;
                    this.smsCodeCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.simPushCheckLoader = !!value;
                },

                // ���������/������ ����� ���������� �������������� �������
                setForgetLoader(value) {
                    this.forgetLoader = !!value;
                    this.smsCodeCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.simPushCheckLoader = !!value;
                },

                // ���������/������ ����� ���������� �����������
                setRegisterLoader(value) {
                    this.registerLoader = !!value;
                    this.smsCodeCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.simPushCheckLoader = !!value;
                },

                resetCheck() {
                    this.smsCode = '';
                    this.userCallTo = '';
                    this.botCallCode = '';
                    this.botSpeechCode = '';
                    this.simPush = '';
                    this.emailCode = '';
                },


                // sms -------------------------
                setSmsCodeLength(value) {
                    this.smsCodeLength = value;
                },
                setSmsCodeTimeout(value) {
                    this.smsCodeTimeout = value;
                },
                setSmsCode(value) {
                    this.smsCode = value;
                },
                setSmsCodeError(value) {
                    this.smsCodeError = value;
                },
                setSmsCodeStartLoader(value) {
                    this.smsCodeStartLoader = value;
                },
                setSmsCodeCheckLoader(value) {
                    this.smsCodeCheckLoader = value;
                },


                //�������� ����� ������ �� ������������
                setUserCallTo(value) {
                    this.userCallTo = value;
                },
                setUserCallStartLoader(value) {
                    this.userCallStartLoader = value;
                },
                setUserCallCheckLoader(value) {
                    this.userCallCheckLoader = value;
                },
                setUserCallTimeout(value) {
                    this.userCallTimeout = value;
                },

                // ������ �� ������
                setBotCallCode(value) {
                    this.botCallCode = value;
                },
                setBotCallLength(value) {
                    this.botCallLength = value;
                },
                setBotCallTimeout(value) {
                    this.botCallTimeout = value;
                },
                setBotCallStartLoader(value) {
                    this.botCallStartLoader = value;
                },
                setBotCallCheckLoader(value) {
                    this.botCallCheckLoader = value;
                },

                //��������� ���
                setBotSpeechCode(value) {
                    this.botSpeechCode = value;
                },
                setBotSpeechLength(value) {
                    this.botSpeechLength = value;
                },
                setBotSpeechTimeout(value) {
                    this.botSpeechTimeout = value;
                },
                setBotSpeechStartLoader(value) {
                    this.botSpeechStartLoader = value;
                },
                setBotSpeechCheckLoader(value) {
                    this.botSpeechCheckLoader = value;
                },

                // SIM-push
                setSimPush(value) {
                    this.simPush = value;
                },
                setSimPushTimeout(value) {
                    this.simPushTimeout = value;
                },
                setSimPushDelay(value) {
                    this.simPushDelay = value;
                },
                setSimPushStartLoader(value) {
                    this.simPushStartLoader = value;
                },
                setSimPushCheckLoader(value) {
                    this.simPushCheckLoader = value;
                },


                // ��� ����� �� ������  ������ ������� �������������
                changeConfirmType() {
                    let list = this.confirmationList;
                    let current = this.confirmationType;
                    if (list.length > 1) {
                        let newconfirmationType = list[0];
                        let index = list.indexOf(current);
                        if (index > -1 && !!list[index + 1]) {
                            newconfirmationType = list[index + 1];
                        }
                        if (newconfirmationType !== current) {
                            this.setConfirmType(newconfirmationType);
                            this.startConfirm();
                        }
                    }
                },

                // ��������� �������� �������� �������������
                setConfirmType(type) {
                        this.resetMessage();
                        this.confirmationType = type;
                },

                //�������� ���� �������������
                showConfirm() {
                    this.isShowConfirm = true;
                },
                // ������ ���� �������������
                hideConfirm() {
                    this.isShowConfirm = false;
                },

                // ����� c�������� �� ������� ��� �������
                resetMessage() {
                    this.message = false;
                    this.error = false;
                },

                //����� ������
                setError(msg) {
                    this.message = msg;
                    this.error = true;
                },

                //����� ���������
                setMessage(msg) {
                    this.message = msg;
                    this.error = false;
                },


                // ������ ������
                parseError(error) {
                    if (error.more && error.more.formattedPhone) {
                        this.setFormattedPhone(error.more.formattedPhone);
                    }

                    switch (error.code) {
                        // case 'ERROR_INVALID_SESSID': {
                        //     if(error.more.sessid)
                        //     {
                        //         BX.message({'bitrix_sessid' : error.more.sessid});
                        //     }
                        //
                        //     break;
                        // }
                        case 'ERROR_NEED_CONFIRM': {
                            this.resetCaptcha();
                            this.startConfirm();
                            this.showConfirm();
                            break;
                        }
                        case 'ERROR_INVALID_PHONE': {
                            this.resetCaptcha();
                            this.hideConfirm();
                            this.setError(error.msg);
                            break;
                        }
                        case 'ERROR_NEED_WAIT_TIMEOUT': {
                            this.resetCaptcha();
                            this.showConfirm();

                            if (this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE) {
                                this.setSmsCodeTimeout(error.more.timeout);
                                this.setSmsCodeLength(error.more.length);

                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL) {
                                this.setUserCallTimeout(error.more.timeout);
                                if (error.more.callTo) {
                                    this.setUserCallTo(error.more.callTo);
                                }
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL) {
                                this.setBotCallTimeout(error.more.timeout);
                                this.setBotCallLength(error.more.length);
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH) {
                                this.setBotSpeechTimeout(error.more.timeout);
                                this.setBotSpeechLength(error.more.length);
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_SIM_PUSH) {
                                this.setSimPushTimeout(error.more.timeout);
                                this.setSimPush(1);
                            }
                            if (this.confirmationType === this.const.CONFIRM_TYPE_EMAIL_CODE) {
                                this.setEmailCodeTimeout(error.more.timeout);
                                this.setEmailCodeLength(1);
                            }


                            break;
                        }
                        case 'ERROR_NEED_CAPTCHA': {
                            this.setError(error.msg);
                            this.setCaptchaCode('');
                            this.setCaptchaId(error.more.captchaId)
                            this.setCaptchaSrc(error.more.captchaSrc)
                            this.setCaptchaLength(error.more.captchaLength)

                            break;
                        }
                        case 'ERROR_INVALID_SMS_CODE': {
                            this.setSmsCode('');
                            this.setSmsCodeError(error.msg);
                            break;
                        }
                        case 'SERVICE_ERROR_UNKNOWN':
                        case 'SERVICE_ERROR_RESPONSE': {
                            this.resetCaptcha();
                            this.showConfirm();
                            this.setError(error.msg);
                            break;
                        }
                        default: {
                            this.setError(error.msg);
                            break;
                        }
                    }
                },

                // ����������� �� �����������
                toRegistration() {
                    this.hideConfirm();
                    this.resetMessage();
                    this.resetCaptcha();
                    this.actionType = Const.ACTION_TYPE_REG;
                    this.loadConsent();
                },

                toAuth() {
                    this.hideConfirm();
                    this.resetMessage();
                    this.resetCaptcha();
                    this.actionType = Const.ACTION_TYPE_AUTH;
                },

                toForget() {
                    this.hideConfirm();
                    this.resetMessage();
                    this.resetCaptcha();
                    this.actionType = Const.ACTION_TYPE_FORGET;
                },

                //�������� ����������
                loadConsent() {
                    if (!this.isEnabledRequestConsent) {
                        return false;
                    }

                    if (this.consentLoader || this.consentText) {
                        return false;
                    }

                    this.lastMethod = this.loadConsent;

                    this.consentLoader = true;

                    this.resetMessage();

                    let requestData = Object.freeze({
                        sessid: BX.bitrix_sessid(),
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        expandData: {...this.expandData},
                        rand: this.data.rand,
                        method: 'getConsent',
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            if (r.response) {

                                this.consentText = r.response.html;

                            } else {
                                this.parseError(r.error);
                            }

                            this.consentLoader = false;
                        },
                        onfailure: (e) => {
                            this.consentLoader = false;
                        }
                    });

                },

                // ���������� ��������
                consentAgree() {
                    this.isConsentReceived = true;
                },

                // ����� ��������
                consentDisagree() {
                    this.isConsentReceived = false;
                },

                // ���������� ��������
                adsAgreementAgree() {
                    this.setAdsAgreement(true);
                },

                // ����� ��������
                adsAgreementDisagree() {
                    this.setAdsAgreement(false);
                },

                setAdsAgreement(flag) {
                    this.isAdsAgreementReceived = !!flag;
                },


                /**
                 * ������ ����� �����
                 */
                refreshCaptcha() {
                    this.resetMessage();

                    this.captchaLoader = true;

                    let requestData = Object.freeze({
                        sessid: BX.bitrix_sessid(),
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        expandData: {...this.expandData},
                        rand: this.data.rand,

                        method: 'refreshCaptcha',
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            if (r.response) {

                                this.captchaId = r.response.captchaId;
                                this.captchaSrc = r.response.captchaSrc;
                                this.captchaLength = r.response.captchaLength;
                                this.captchaCode = '';

                            } else {
                                this.parseError(r.error);
                            }

                            this.captchaLoader = false;
                        },
                        onfailure: (e) => {
                            this.captchaLoader = false;
                        }
                    });
                },

                /**
                 * ����� ��������� �����
                 */
                resetCaptcha() {
                    this.captchaCode = '';
                    this.captchaId = '';
                    this.captchaSrc = '';
                },

                /**
                 * ����� ��������� �����
                 */
                hideCaptcha() {
                    this.captchaSrc = false;
                },

                //���������  ���� � ��������
                setCaptchaCode(value) {
                    this.captchaCode = value;
                },
                setCaptchaId(value) {
                    this.captchaId = value;
                },
                setCaptchaSrc(value) {
                    this.captchaSrc = value;
                },
                setCaptchaLength(value) {
                    this.captchaLength = +value;
                },

                //������ ������ ��������
                startConfirm() {
                    switch (this.confirmationType) {
                        case this.const.CONFIRM_TYPE_SMS_CODE: {
                            this.startConfirmSmsCode();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_USER_CALL: {
                            this.startConfirmUserCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_CALL: {
                            this.startConfirmBotCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_SPEECH: {
                            this.startConfirmBotSpeech();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_SIM_PUSH: {
                            this.startConfirmSimPush();
                            break;
                        }
                    }
                },

                /**
                 * ������ �������� ����� ��� � ���
                 */
                startConfirmSmsCode() {
                    if (this.smsCodeStartLoader) {
                        return false;
                    }

                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSmsCodeStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSmsCodeLength(r.response.length);
                                this.setSmsCodeTimeout(r.response.timeout);

                                this.resetCaptcha();
                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setSmsCodeStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSmsCodeStartLoader(false);
                        }
                    });
                },

                /**
                 * ������ �������� ����� ������ �� ������������
                 */
                startConfirmUserCall() {
                    if (this.userCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()


                    this.setUserCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);

                                this.setUserCallTo(r.response.callTo);
                                this.setUserCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setUserCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setUserCallStartLoader(false);
                        }
                    });
                },

                /**
                 * ������ ������������� ����� ������ �� ����
                 */
                startConfirmBotCall() {
                    if (this.botCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotCallLength(r.response.length);
                                this.setBotCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotCallStartLoader(false);
                        }
                    });
                },

                /**
                 * ������ ������������� ����� ��������� ���
                 */
                startConfirmBotSpeech() {
                    if (this.botSpeechStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotSpeechStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotSpeechLength(r.response.length);
                                this.setBotSpeechTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotSpeechStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotSpeechStartLoader(false);
                        }
                    });
                },
                /**
                 * ������ ������������� ����� SIM-push
                 */
                startConfirmSimPush() {
                    if (this.simPushStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSimPushStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSimPushTimeout(r.response.timeout);
                                this.setSimPush(1);

                                if (!!r.response.delay) {
                                    if (this._simPushDelayTimeout) {
                                        clearTimeout(this._simPushDelayTimeout);
                                    }

                                    this.setSimPushDelay(+r.response.delay);
                                    this._simPushDelayTimeout = setTimeout(() => {
                                        this.setSimPushDelay(0);
                                    }, 1000 * (+r.response.delay));
                                }

                                this.resetCaptcha()

                                this.showConfirm();


                            } else {
                                this.parseError(r.error);
                            }

                            this.setSimPushStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSimPushStartLoader(false);
                        }
                    });
                },

                //  �����������
                authByPassword() {
                    if (this.authByPasswordLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setAuthByPasswordLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'authByPassword',
                        ple: this.ple,
                        password: this.password,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setIsAuthorized(true);
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setAuthByPasswordLoader(false);
                        },
                        onfailure: (e) => {
                            this.setAuthByPasswordLoader(false);
                        }
                    });
                },

                //  �����������
                authByPhone() {
                    if (this.authByPhoneLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setAuthByPhoneLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'authByPhone',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                                this.setAuthByPhoneLoader(false);
                            }


                        },
                        onfailure: (e) => {
                            this.setAuthByPhoneLoader(false);
                        }
                    });
                },

                //  ��������� ������ ����� ������� ����������� � ���������� ���������� ��� ����������� ��������
                afterAuthSuccessful(data) {
                    if (data.redirect && this.isEnabledRedirect) {
                        location.href = data.redirect;
                    } else if (data.reload && this.isEnabledReload) {
                        location.reload();
                    } else {
                        this.setIsAuthorized(true);
                        this.setAuthByPhoneLoader(false);
                    }
                },

                // �������������� ������
                forget() {
                    if (this.forgetLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setForgetLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'forget',
                        phone: this.phone,
                        email: this.email,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setMessage(r.response.msg);

                                if (r.response.isAuthorized) {
                                    this.setIsAuthorized(true);
                                    this.afterAuthSuccessful(r.response);
                                }

                            } else {
                                this.parseError(r.error);
                            }

                            this.setForgetLoader(false);
                        },
                        onfailure: (e) => {
                            this.setForgetLoader(false);
                        }
                    });
                },

                // �����������
                register() {
                    if (this.registerLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setRegisterLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'register',
                        fio: this.fio,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        secondName: this.secondName,
                        birthday: this.birthday,
                        dadataItem: this.dadataItem,
                        phone: this.phone,
                        login: this.login,
                        email: this.email,
                        password: this.password,
                        consentUrl: window.location.href,
                        adsAgreement: this.isAdsAgreementReceived,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setIsAuthorized(true);
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setRegisterLoader(false);
                        },
                        onfailure: (e) => {
                            this.setRegisterLoader(false);
                        }
                    });
                },


                //�������� �������������,  �� ���� ����� ����������� ��������� ������� �����������,
                // ������������, �������������� ������� � ������ ����������� ��� �������������
                checkConfirm() {
                    switch (this.actionType) {
                        case Const.ACTION_TYPE_AUTH: {
                            this.authByPhone();
                            break;
                        }
                        case Const.ACTION_TYPE_REG: {
                            this.register();
                            break;
                        }
                        case Const.ACTION_TYPE_FORGET: {
                            this.forget();
                            break;
                        }
                    }
                },
                onCommandCallUserCheck() {
                    if (this.confirmationType !== this.const.CONFIRM_TYPE_USER_CALL) {
                        return true;
                    }
                    if (!this.isShowConfirm) {
                        return true;
                    }
                    this.checkConfirm();
                },

                // auth by email code
                setEmailCode(value) {
                    this.emailCode = value;
                },
                setEmailCodeTimeout(value) {
                    this.emailCodeTimeout = value;
                },

                setEmailCodeLength(value) {
                    this.emailCodeLength = value;
                },

                setEmailCodeStartLoader(value) {
                    this.emailCodeStartLoader = value;
                },
                setEmailCodeCheckLoader(value) {
                    this.emailCodeCheckLoader = value;
                },

                startConfirmEmailCode() {
                    if (this.emailCodeStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setEmailCodeStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_EMAIL_CODE,
                        email: this.email,
                        phone: this.phone,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setEmail(r.response.email);
                                this.setEmailCodeLength(r.response.length);
                                this.setEmailCodeTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setEmailCodeStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setEmailCodeStartLoader(false);
                        }
                    });
                },

                //  �����������
                authByEmailCode() {
                    if (this.emailCodeCheckLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setEmailCodeCheckLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'authByEmail',
                        email: this.email
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setIsAuthorized(true);
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setEmailCodeCheckLoader(false);
                        },
                        onfailure: (e) => {
                            this.setEmailCodeCheckLoader(false);
                        }
                    });
                },

            },
            template: `<BXmakerAuthuserphoneEnter :key="data.rand" />`,
        });

        this.instance.mount('#' + this.rootId);

        return new Promise((resolve, reject) => resolve());
    }

}